
import {initWebComponent} from "@/helpers/web-component-helper";
import {toggleActiveToolButton} from "@/helpers/layer-tools-helper";

export class LayerInfoToolsButtonsComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
     <div class="card m-2">
        <div class="card-body p-2">
            <div class="mt-1">
                <div class="btn-group btn-group-toggle bg-light p-1 d-flex" data-toggle="buttons">
                    <label class="btn btn-default btn-tools btn-sm md-btn-flat waves-effect active">
                        <layer-info-tools-measure-button></layer-info-tools-measure-button>
                    </label>
<!--                    <label class="btn btn-default btn-tools btn-sm md-btn-flat waves-effect">-->
<!--                        <layer-info-tools-draw-button></layer-info-tools-draw-button>-->
<!--                    </label>-->
                    <label class="btn btn-default btn-tools btn-sm md-btn-flat waves-effect">
                        <layer-info-tools-mutation-button></layer-info-tools-mutation-button>
                    </label>
                </div>
            </div>
        </div>
    </div>
`;

        initWebComponent(this, template)
    }
}

